const THEME_ON_CHANGE = 'THEME_ON_CHANGE';
const THINK_TOOL_TAB_TOGGLE = 'THINK_TOOL_TAB_TOGGLE';
const NEW_MESSAGE_COMPOSE_TOGGLE = 'NEW_MESSAGE_COMPOSE_TOGGLE';
const TL_USER_VERSION_TOGGLE = 'TL_USER_VERSION_TOGGLE';

const API_GET_CLIENT_BACKGROUND_REQUEST = 'API_GET_CLIENT_BACKGROUND_REQUEST';
const API_GET_CLIENT_BACKGROUND_SUCCESS = 'API_GET_CLIENT_BACKGROUND_SUCCESS';
const API_GET_CLIENT_BACKGROUND_FAILURE = 'API_GET_CLIENT_BACKGROUND_FAILURE';

const TOGGLE_COMPOSE_MESSAGE = 'TOGGLE_COMPOSE_MESSAGE';
const TOGGLE_VIEW_MESSAGE = 'TOGGLE_VIEW_MESSAGE';
const TOGGLE_THINKTOOL_POPUP = 'TOGGLE_THINKTOOL_POPUP';

const TOGGLE_ADD_PROGRAMME_POPUP = 'TOGGLE_ADD_PROGRAMME_POPUP';
const TOGGLE_RESUBMISSION_POPUP = 'TOGGLE_RESUBMISSION_POPUP';
const TOGGLE_SUPPLEMENTARY_POPUP = 'TOGGLE_SUPPLEMENTARY_POPUP';
const TOGGLE_DECLINE_INVITE_REASON_POPUP = 'TOGGLE_DECLINE_INVITE_REASON_POPUP';
const TOGGLE_DELETE_USER_POPUP = 'TOGGLE_DELETE_USER_POPUP';
const TOGGLE_ADD_USER_POPUP = 'TOGGLE_ADD_USER_POPUP';
const TOGGLE_ADD_USER_POPUP_SUCCESS = 'TOGGLE_ADD_USER_POPUP_SUCCESS';

const TOGGLE_USER_DASHBOARD = 'TOGGLE_USER_DASHBOARD';
const SAVE_EDIT_POPUP = 'SAVE_EDIT_POPUP';
const MANAGER_POPUP = 'MANAGER_POPUP';
const TOGGLE_NOTIFICATION = 'TOGGLE_NOTIFICATION';
const RESET_NOTIFICATION = 'RESET_NOTIFICATION';
const TOGGLE_VIEW_ATTACH = 'TOGGLE_VIEW_ATTACH';
const TOGGLE_FOOTER_POPUP = 'TOGGLE_FOOTER_POPUP';
const TOGGLE_REFERER_PAGE = 'TOGGLE_REFERER_PAGE';
const SHOW_SAVE_MODAL = 'SHOW_SAVE_MODAL';
const SHOW_RETURN_MODAL = 'SHOW_RETURN_MODAL';
const SET_RETURN_ITEM = 'SET_RETURN_ITEM';
const SET_PROFILE_POPUP = 'SET_PROFILE_POPUP';

const TOGGLE_TOUR_POPUP = 'TOGGLE_TOUR_POPUP';

const TOGGLE_MINIMIZE_POPUP = 'TOGGLE_MINIMIZE_POPUP';

const SET_DELETE_INDEX = 'SET_DELETE_INDEX';

const SET_POPUPS = 'SET_POPUPS';
const TOGGLE_EXTENSION_POPUP  = 'TOGGLE_EXTENSION_POPUP';
const SHOW_SUBMIT_MODAL  = 'SHOW_SUBMIT_MODAL';
const SHOW_REMOVE_MODAL  = 'SHOW_REMOVE_MODAL';
const SHOW_DISABILITIES = 'SHOW_DISABILITIES';
const SET_REMOVE_ID  = 'SET_REMOVE_ID';
const SET_LAST_SCHOOL  = 'SET_LAST_SCHOOL';
const SET_AREA  = 'SET_AREA';

const SET_SIGHT  = 'SET_SIGHT';
const SET_HEAR = 'SET_HEAR';
const SET_WALK  = 'SET_WALK';
const SET_COMM = 'SET_COMM';
const SET_MEMORY = 'SET_MEMORY';
const SET_SELF_CARE = 'SET_SELF_CARE';
export const setSight = payload => ({
  type: SET_SIGHT,
  payload,
});
export const setHear = payload => ({
  type: SET_HEAR,
  payload,
});
export const setWalk = payload => ({
  type: SET_WALK,
  payload,
});
export const setComm = payload => ({
  type: SET_COMM,
  payload,
});
export const setMemory = payload => ({
  type: SET_MEMORY,
  payload,
});
export const setSelfCare = payload => ({
  type: SET_SELF_CARE,
  payload,
});
export const setLastSchool = payload => ({
  type: SET_LAST_SCHOOL,
  payload,
});
export const setArea = payload => ({
  type: SET_AREA,
  payload,
});
export const setPopUps = payload => ({
  type: SET_POPUPS,
  payload,
});
export const showDisabilties = payload => ({
  type: SHOW_DISABILITIES,
  payload,
});


export const showRemoveModal = payload => ({
  type: SHOW_REMOVE_MODAL,
  payload,
});
export const setRemoveId = payload => ({
  type: SET_REMOVE_ID,
  payload,
});


export const showSaveModal = payload => ({
  type: SHOW_SAVE_MODAL,
  payload,
});

export const setReturnItem = payload => ({
  type: SET_RETURN_ITEM,
  payload,
});


export const showReturnModal = payload => ({
  type: SHOW_RETURN_MODAL,
  payload,
});



export const showSubmitModal = payload => ({
  type: SHOW_SUBMIT_MODAL,
  payload,
});


export const toggleFooterPopup = payload => ({
  type: TOGGLE_FOOTER_POPUP,
  payload,
});

export const toggleMinimizePopup = payload => ({
  type: TOGGLE_MINIMIZE_POPUP,
  payload,
});

export const toggleViewAttach = payload => ({
  type: TOGGLE_VIEW_ATTACH,
  payload,
});

export const toggleSaveEditPopup = payload => ({
  type: SAVE_EDIT_POPUP,
  payload,
});

export const toggleManagerPopup = payload => ({
  type: MANAGER_POPUP,
  payload,
});

export const toggleThinkToolPopup = payload => ({
  type: TOGGLE_THINKTOOL_POPUP,
  payload,
});

export const toggleAddProgrammePopup = payload => ({
  type: TOGGLE_ADD_PROGRAMME_POPUP,
  payload,
});

export const toggleResubmissionPopup = payload => ({
  type: TOGGLE_RESUBMISSION_POPUP,
  payload,
});
export const toggleSupplementaryPopup = payload => ({
  type: TOGGLE_SUPPLEMENTARY_POPUP,
  payload,
});
export const toggleExtensionPopup = payload => ({
  type: TOGGLE_EXTENSION_POPUP,
  payload,
});



export const toggleDeclineInviteReasonPopup = payload => ({
  type: TOGGLE_DECLINE_INVITE_REASON_POPUP,
  payload,
});

export const toggleAddUserPopup = payload => ({
  type: TOGGLE_ADD_USER_POPUP,
  payload,
});

export const toggleDeleteUserPopup = payload => ({
  type: TOGGLE_DELETE_USER_POPUP,
  payload,
});

export const toggleAddUserPopupSuccess = payload => ({
  type: TOGGLE_ADD_USER_POPUP_SUCCESS,
  payload,
});

export const toggleComposeMessage = payload => ({
  type: TOGGLE_COMPOSE_MESSAGE,
  payload,
});

export const toggleViewMessage = payload => ({
  type: TOGGLE_VIEW_MESSAGE,
  payload,
});

export const getClientBackGroundRequest = payload => ({
  type: API_GET_CLIENT_BACKGROUND_REQUEST,
  payload,
});

export const getClientBackGroundSuccess = payload => ({
  type: API_GET_CLIENT_BACKGROUND_SUCCESS,
  payload,
});

export const setProfilePopup = payload => ({
  type: SET_PROFILE_POPUP,
  payload,
});

export const getClientBackGroundFailure = payload => ({
  type: API_GET_CLIENT_BACKGROUND_FAILURE,
  payload,
});

export const toggleNewMessageCompose = payload => ({
  type: NEW_MESSAGE_COMPOSE_TOGGLE,
  payload,
});

export const toggleThinkToolTab = payload => ({
  type: THINK_TOOL_TAB_TOGGLE,
  payload,
});

export const toggleTlUserVersion = payload => ({
  type: TL_USER_VERSION_TOGGLE,
  payload,
});

export const toggleUserDashboard = payload => ({
  type: TOGGLE_USER_DASHBOARD,
  payload,
});

export const toggleNotification = payload => ({
  type: TOGGLE_NOTIFICATION,
  payload,
});

export const resetNotification = () => ({
  type: RESET_NOTIFICATION,
});

export const toggleTourPopup = payload => ({
  type: TOGGLE_TOUR_POPUP,
  payload,
});

export const toggleRefererPage = payload => ({
  type: TOGGLE_REFERER_PAGE,
  payload,
});

export const setDeleteIndex = payload => ({
  type: SET_DELETE_INDEX,
  payload,
});
const initialState = {
  refererPage: '/home',
  isFooterPopup: false,
  notification: false,
  notificationMessage: '',
  notificationType: 'success',
  saveEditPopup: false,
  thinkToolPopup: false,
  addProgrammePopup: false,
  declineInviteReasonPopup: false,
  addUserPopup: false,
  deleteUserPopup: false,
  addUserPopupSuccess: false,
  composeMessage: false,
  viewMessage: false,
  clientBackground: null,
  clientBackgroundFetching: false,
  isLight: true,
  isOpenedThinkToolTab: false,
  isShowNewMessageCompose: false,
  isTlUserVersionsOpened: false,
  isUserDashboardOpened: false,
  isViewAttach: false,
  tourPopupFlag: false,
  showProfile:false,
  managerPopup:false,
  showMinimizePopup:false,
  windowDeleteIndex: 0,
  resubmissionPopup:false,
  popups:[],
  extensionPopup:false,
  supplementaryPopup:false,
  showSubmitModal:false,
  showSaveModal:false,
  showReturnModal:false,
  returnItem:null,
  showRemoveModal:false,
  removeId:null,
  showDisabilties:false,
  lastSchool:'',
  saAreaCode:'',
  sightRating:0,
  hearRating:0,
  walkRating:0,
  commRating:0,
  memoryRating:0,
  selfcareRating:0
};

if (window.localStorage.getItem('isLight') !== null) {
  initialState.isLight = window.localStorage.getItem('isLight') === 'true';
}

if (window.localStorage.getItem('isLight') === null) {
  window.localStorage.setItem('isLight', initialState.isLight);
}

export const viewReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SIGHT:

      return {
        ...state,
        sightRating: action.payload,
      };
    case SET_HEAR:
      console.log('cookie last school', action.payload)
      return {
        ...state,
        hearRating: action.payload,
      };
    case SET_WALK:
      console.log('cookie last school', action.payload)
      return {
        ...state,
        walkRating: action.payload,
      };
    case SET_COMM:
      console.log('cookie last school', action.payload)
      return {
        ...state,
        commRating: action.payload,
      };
    case SET_MEMORY:
      console.log('cookie last school', action.payload)
      return {
        ...state,
        memoryRating: action.payload,
      };
    case SET_SELF_CARE:
      console.log('cookie last school', action.payload)
      return {
        ...state,
        selfcareRating: action.payload,
      };
    case SET_LAST_SCHOOL:
      console.log('cookie last school', action.payload)
      return {
        ...state,
        lastSchool: action.payload,
      };
    case SET_AREA:
      return {
        ...state,
        saAreaCode: action.payload,
      };
  
    case SHOW_DISABILITIES:
      return {
        ...state,
        showDisabilties: action.payload,
      };
    case SET_REMOVE_ID:
      return {
        ...state,
        removeId: action.payload,
      };
    case SHOW_REMOVE_MODAL:
      return {
        ...state,
        showRemoveModal: action.payload,
      };
    case SHOW_RETURN_MODAL:
      return {
        ...state,
        showReturnModal: action.payload,
      };
      case SET_RETURN_ITEM:
        console.log('cookie return SSS', action.payload)
        return {
          ...state,
          returnItem: action.payload,
        };
    case SHOW_SAVE_MODAL:
      return {
        ...state,
        showSaveModal: action.payload,
      };
    case SHOW_SUBMIT_MODAL:
      return {
        ...state,
        showSubmitModal: action.payload,
      };
    case TOGGLE_REFERER_PAGE:
      return {
        ...state,
        refererPage: action.payload,
      };

      case SET_DELETE_INDEX:
        console.log('SPLIce5', action.payload)
        return {
          ...state,
          windowDeleteIndex: action.payload,
        };
        case SET_POPUPS:
          console.log('POPUP KILL 2', action.payload)
          return {
            ...state,
            popups: action.payload,
          };

      case TOGGLE_MINIMIZE_POPUP:
        return {
          ...state,
          showMinimizePopup: action.payload,
        };

    case MANAGER_POPUP:
      return {
        ...state,
        managerPopup: action.payload,
      };
      case SET_PROFILE_POPUP:
     
        return {
          ...state,
          showProfile: action.payload,
        };
    case TOGGLE_FOOTER_POPUP:
      return {
        ...state,
        isFooterPopup: action.payload,
      };
    case TOGGLE_VIEW_ATTACH:
      return {
        ...state,
        isViewAttach: action.payload,
      };
    case RESET_NOTIFICATION:
      return {
        ...state,
        notification: false,
      };
    case TOGGLE_NOTIFICATION:
      
      return {
        ...state,
        notification: action.payload.value,
        notificationMessage: action.payload.message,
        notificationType: action.payload.type,
      };
    case SAVE_EDIT_POPUP:
      return {
        ...state,
        saveEditPopup: action.payload,
      };
    case TOGGLE_THINKTOOL_POPUP:
      return {
        ...state,
        thinkToolPopup: action.payload,
      };
    case TOGGLE_ADD_PROGRAMME_POPUP:
      return {
        ...state,
        addProgrammePopup: action.payload,
      };
      case TOGGLE_RESUBMISSION_POPUP:
        return {
          ...state,
          resubmissionPopup: action.payload,
        };
        case TOGGLE_SUPPLEMENTARY_POPUP:
        return {
          ...state,
          supplementaryPopup: action.payload,
        };
        case TOGGLE_EXTENSION_POPUP:
          return {
            ...state,
            extensionPopup: action.payload,
          };
    case TOGGLE_DECLINE_INVITE_REASON_POPUP:
      return {
        ...state,
        declineInviteReasonPopup: action.payload,
      };
    case TOGGLE_ADD_USER_POPUP:
      return {
        ...state,
        addUserPopup: action.payload,
      };
    case TOGGLE_DELETE_USER_POPUP:
      return {
        ...state,
        deleteUserPopup: action.payload,
      };
    case TOGGLE_ADD_USER_POPUP_SUCCESS:
      return {
        ...state,
        addUserPopupSuccess: action.payload,
      };
    case TOGGLE_COMPOSE_MESSAGE:
      return {
        ...state,
        composeMessage: action.payload,
      };
    case TOGGLE_VIEW_MESSAGE:
      return {
        ...state,
        viewMessage: action.payload,
      };
    case API_GET_CLIENT_BACKGROUND_FAILURE:
      return {
        ...state,
        clientBackgroundFetching: false,
        error: action.payload,
      };
    case API_GET_CLIENT_BACKGROUND_SUCCESS:
      return {
        ...state,
        clientBackground: action.payload,
        clientBackgroundFetching: false,
      };
    case API_GET_CLIENT_BACKGROUND_REQUEST:
      return {
        ...state,
        clientBackgroundFetching: true,
      };
    case NEW_MESSAGE_COMPOSE_TOGGLE:
      return {
        ...state,
        isShowNewMessageCompose: action.payload,
      };
    case THINK_TOOL_TAB_TOGGLE:
      return {
        ...state,
        isOpenedThinkToolTab: action.payload,
      };
    case THEME_ON_CHANGE:
      window.localStorage.setItem('isLight', !state.isLight);
      return {
        ...state,
        isLight: !state.isLight,
      };
    case TL_USER_VERSION_TOGGLE:
      return {
        ...state,
        isTlUserVersionsOpened: action.payload,
      };
    case TOGGLE_USER_DASHBOARD:
      return {
        ...state,
        isUserDashboardOpened: action.payload,
      };
    case TOGGLE_TOUR_POPUP:
      return {
        ...state,
        tourPopupFlag: action.payload,
      };
    default:
      return state;
  }
};
